import React, { PropsWithChildren } from 'react';

type FormProps = {
  onSubmit: () => void;
};

export const Form: React.FC<PropsWithChildren<FormProps>> = ({ children, onSubmit }) => {
  return <form onSubmit={onSubmit}>{children}</form>;
};
